module.exports = __webpack_public_path__ + "img/23_7.2a99f5d1.png";